// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"c78583b9","977":"27b45144"}[chunkId] + ".chunk.js");